import api from '../api';

export async function getPioneerSummary(username) {
  const safeUsername = encodeURIComponent(
    String(username || '').trim()
  );

  if (!safeUsername) {
    throw new Error('A username is required.');
  }

  const { data } = await api.get(
    `/users/${safeUsername}/summary`
  );

  return data;
}



export async function recordPioneerSummaryEvent(
  username,
  eventType,
  entryPoint,
  extra = {}
) {
  const safeUsername = encodeURIComponent(
    String(username || '').trim()
  );

  if (!safeUsername) {
    throw new Error('A username is required.');
  }

  const { data } = await api.post(
    `/users/${safeUsername}/summary/events`,
    {
      eventType,
      entryPoint,
      ...extra,
    }
  );

  return data;
}
